export default __webpack_public_path__ + "335f15ba7aee165f1cc163b1b6a65ae0.svg";